import { Box, Typography } from "@mui/material";

export const Error = () => {
  return (
    <Box
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Typography variant={"h4"} gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant={"body1"}>Please try again later</Typography>
    </Box>
  );
};
